import { useEffect, useState } from 'react'
import { FormGroup, Input } from 'reactstrap'
import './styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleUp } from '@fortawesome/free-solid-svg-icons'

function Footer({
  isSpeaking,
  onMicToggle,
  allowInput,
  onTextAnswer,
  showModal,
  setShowModal,
  canInterviewContinue,
  step,
}) {
  const [micOn, setMicOn] = useState(false)
  const [textAnswer, setTextAnswer] = useState('')

  useEffect(() => {
    if (isSpeaking) {
      setMicOn(false)
      onMicToggle(false)
    }
  }, [isSpeaking, onMicToggle])

  const handleTextSubmit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    if (textAnswer.trim()) {
      onTextAnswer(textAnswer.trim())
      setTextAnswer('')
    }
  }

  // Disable Answer button during intro, wait, or when AI is speaking
  const isAnswerDisabled = isSpeaking || step === 'intro' || step === 'wait'

  return (
    <div
      className='position-absolute bottom-0 pb-3 text-center d-flex flex-column align-items-center justify-content-center mx-auto w-100'
      style={{ backgroundColor: '#212121' }}
    >
      {allowInput && step !== 'conclusion' ? (
        <div className='w-50'>
          <FormGroup className='ml-0 position-relative'>
            <Input
              id='answer'
              name='answer'
              placeholder='Type answer...'
              type='textarea'
              rows={3}
              className='p-3 answer-input'
              disabled={isSpeaking}
              value={textAnswer}
              onChange={(e) => setTextAnswer(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  handleTextSubmit(e)
                }
              }}
            />
            <FontAwesomeIcon
              role='button'
              icon={faCircleUp}
              className='position-absolute bottom-3 right-3 text-white'
              size='2x'
              onClick={handleTextSubmit}
            />
          </FormGroup>
        </div>
      ) : null}

      {canInterviewContinue && step !== 'conclusion' ? (
        <div
          className={`${!allowInput ? 'mb-5' : ''} d-flex align-items-center`}
        >
          {!micOn && (!allowInput || !textAnswer.trim()) ? (
            <button
              disabled={isAnswerDisabled}
              className='btn btn-success px-4 py-2'
              onClick={() => {
                if (isAnswerDisabled) return
                setMicOn(true)
                onMicToggle(true)
              }}
            >
              Answer
            </button>
          ) : !micOn && allowInput && textAnswer.trim() ? (
            <button
              disabled={isAnswerDisabled}
              className='btn btn-primary px-4 py-2'
              onClick={(e) => {
                e.preventDefault()
                handleTextSubmit(e)
              }}
            >
              Submit Answer
            </button>
          ) : (
            <div className='d-flex align-items-center'>
              <div className='recording-indicator mr-3'>
                <span className='dot'></span>
              </div>
              <button
                className='btn btn-danger px-4 py-2'
                onClick={() => {
                  setMicOn(false)
                  onMicToggle(false)
                  // Submit text if there's any when stopping mic
                  if (textAnswer.trim()) {
                    onTextAnswer(textAnswer.trim())
                    setTextAnswer('')
                  }
                }}
              >
                Submit Answer
              </button>
            </div>
          )}
        </div>
      ) : null}
      {!canInterviewContinue && !showModal && (
        <button
          onClick={() => setShowModal(true)}
          className='btn btn-success mb-5'
        >
          Start Interview
        </button>
      )}
    </div>
  )
}

export default Footer
